export default __webpack_public_path__ + "static/media/item-3.0815bc3b.webp";